var n;!function(n){n.CARDS="cards",n.LINK="link"}(n||(n={}));export{n as PaymentMethodCardVariant};
